// extracted by mini-css-extract-plugin
export default {"container":"UserAdmin_container__5qm0M"};